module.exports = __webpack_public_path__ + "static/media/roller01.20ec6044.png";